import React, { useState, useEffect } from 'react'
import { Autocomplete } from '@material-ui/lab';
import { matchSorter } from 'match-sorter';
import { Link } from 'react-router-dom';

import {
  TextField, Typography,
} from '@material-ui/core';

const filterOptions = (options, inputValue, nameKey) => {
  return matchSorter(options, inputValue, {keys: [nameKey]});
}

export default function ContractNumberSearch(props) {

  var {
    initialValue,
    error,
     onType,
    placeholder = 'Type to search',
    label,
    disableUnderline = false,
    nameKey
  } = props;

  initialValue = initialValue || null;

  const [Options, SetOptions] = useState([]);

  const handleChange = (event, value) => {
    
    event.preventDefault();

    value = value.trim();

    if (value.length > 0) {

      let candidates = [];

      if (value.match(/[a-z]/i)) {
        candidates.push(value);
      } else {
        candidates.push(`SEL-${value}`);
      }

      onType(candidates).then(res => {
        SetOptions(res || []);
      })

    } else {
      SetOptions([])
    }

  }

  useEffect(() => {
    SetOptions(Options || []);
  }, [Options]);

  return (
    <div style={props.style}>
      {onType && <Autocomplete
        options={Options}
        getOptionSelected={(option, value)=> option.id === value.id}
        autoHighlight={true}
        fullWidth
        disableCloseOnSelect={true}
        onChange={(e) => {e.preventDefault()}}
        onInputChange={(event, value) => { handleChange(event, value)}}
        noOptionsText='No match found'
        size='small'
        filterOptions={(options, {inputValue}) => filterOptions(options, inputValue, nameKey)}
        renderInput={(params) => <TextField
          {...params}
          label={label}
          fullWidth
          onKeyDown={e => {
            if (e.key === 'Enter') {
              e.preventDefault();
              e.stopPropagation();
              return
            }
          }}
          {...(disableUnderline && {InputProps: {...params.InputProps, disableUnderline: !error}})}
          {...(error && { error: true })}
          placeholder={placeholder}
          InputLabelProps={{ shrink: true }}
          variant='outlined'
        />}
        renderOption={(option) => (
          <Link onClick={event => event.stopPropagation()} to={`/purchase-orders/${option.id}`}><Typography>{option[nameKey]}</Typography></Link>
        )}
      />}
    </div>
  )
}
